(function () {
  const BUTTON_SELECTOR = '.beae-variant-size-guide-btn';
  const INIT_ATTR = 'data-myn2o-size-guide-initialized';

  // Click listener works even if Beae dynamically renders the button.
  document.addEventListener('click', function (event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    waitForSizeGuide();
  });

  function waitForSizeGuide() {
    let tries = 0;
    const maxTries = 60;

    const timer = setInterval(function () {
      tries++;

      const context = findSizeGuideContext();

      if (context) {
        clearInterval(timer);
        initSizeGuide(context.root);
        return;
      }

      if (tries >= maxTries) {
        clearInterval(timer);
        console.warn('[MYN2O] Size guide HTML was not found after popup open.');
      }
    }, 100);
  }

  function isVisible(el) {
    if (!el) return false;

    const style = window.getComputedStyle(el);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      el.getClientRects().length > 0
    );
  }

  function getCommonAncestor(a, b) {
    if (!a || !b) return null;

    const parents = [];
    let node = a;

    while (node) {
      parents.push(node);
      node = node.parentElement;
    }

    node = b;

    while (node) {
      if (parents.includes(node)) return node;
      node = node.parentElement;
    }

    return null;
  }

  function findSizeGuideContext() {
    // The supplied HTML always has:
    // .tabs
    // #women.size-section
    // #men.size-section
    // #kids.size-section
    // #jewelry.size-section
    //
    // Prefer the visible copy because Beae may leave a hidden template in the DOM.
    const allTabs = Array.from(document.querySelectorAll('.tabs'));

    for (const tabs of allTabs) {
      if (!isVisible(tabs)) continue;

      let scope = tabs.parentElement;

      // Walk upward until this same DOM branch contains the matching sections.
      while (scope && scope !== document.documentElement) {
        const women = scope.querySelector('#women.size-section');
        const men = scope.querySelector('#men.size-section');
        const kids = scope.querySelector('#kids.size-section');
        const jewelry = scope.querySelector('#jewelry.size-section');

        if (women && men && kids && jewelry) {
          const common = getCommonAncestor(tabs, women);
          return {
            root: common || scope,
            tabs: tabs
          };
        }

        scope = scope.parentElement;
      }
    }

    return null;
  }

  function initSizeGuide(root) {
    if (!root) return;

    // If Beae reuses the same popup DOM, don't bind duplicate listeners.
    if (root.getAttribute(INIT_ATTR) === 'true') {
      refreshInitialCharts(root);
      return;
    }

    root.setAttribute(INIT_ATTR, 'true');

    const W = {
      'w-tops': {name:'Tops', note:'Fitted and regular tops are primarily chosen by bust, then waist and hip.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37'],['S','4–6','35–36','28–29','38–39'],['M','8–10','37–38','30–31','40–41'],['L','12–14','39–41','32–34','42–44'],['XL','16–18','42–44','35–37','45–47'],['2XL','20–22','45–47','38–40','48–50'],['3XL','24–26','48–50','41–43','51–53'],['4XL','28–30','51–53','44–46','54–56']]},
      'w-jeans': {name:'Jeans', note:'Denim sizing is driven by waist and hip. Choose the inseam separately when offered.', cols:['Size','US / Denim Waist','Waist (in)','Hip (in)','Inseam Options (in)'], rows:[
        ['XS','24–25','24–25','34–35','28 / 30 / 32'],['S','26–27','26–27','36–37','28 / 30 / 32'],['M','28–29','28–29','38–39','28 / 30 / 32'],['L','30–31','30–31','40–41','28 / 30 / 32'],['XL','32–34','32–34','42–44','28 / 30 / 32'],['2XL','35–37','35–37','45–47','28 / 30 / 32'],['3XL','38–40','38–40','48–50','28 / 30 / 32'],['4XL','41–43','41–43','51–53','28 / 30 / 32']]},
      'w-shorts': {name:'Shorts', note:'For shorts, match your natural waist and fullest hip; inseam varies by short style.', cols:['Size','US Size','Waist (in)','Hip (in)','Typical Inseam (in)'], rows:[
        ['XS','0–2','25–26','35–36','2–4'],['S','4–6','27–28','37–38','3–5'],['M','8–10','29–30','39–40','4–6'],['L','12–14','31–33','41–43','5–7'],['XL','16–18','34–36','44–46','5–8'],['2XL','20–22','37–39','47–49','5–8'],['3XL','24–26','40–42','50–52','6–9'],['4XL','28–30','43–45','53–55','6–9']]},
      'w-skirts': {name:'Skirts', note:'Skirts are generally sized from the waistband and hip. Length is style-specific.', cols:['Size','US Size','Waist (in)','Hip (in)','Typical Length Note'], rows:[
        ['XS','0–2','25–26','35–36','Mini / Midi / Maxi'],['S','4–6','27–28','37–38','Mini / Midi / Maxi'],['M','8–10','29–30','39–40','Mini / Midi / Maxi'],['L','12–14','31–33','41–43','Mini / Midi / Maxi'],['XL','16–18','34–36','44–46','Mini / Midi / Maxi'],['2XL','20–22','37–39','47–49','Mini / Midi / Maxi'],['3XL','24–26','40–42','50–52','Mini / Midi / Maxi'],['4XL','28–30','43–45','53–55','Mini / Midi / Maxi']]},
      'w-tees': {name:'T-Shirts', note:'T-shirts use bust/chest as the primary reference. Relaxed and oversized fits intentionally add ease.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)'], rows:[
        ['XS','0–2','32–33','25–26','35–36'],['S','4–6','34–35','27–28','37–38'],['M','8–10','36–37','29–30','39–40'],['L','12–14','38–40','31–33','41–43'],['XL','16–18','41–43','34–36','44–46'],['2XL','20–22','44–46','37–39','47–49'],['3XL','24–26','47–49','40–42','50–52'],['4XL','28–30','50–52','43–45','53–55']]},
      'w-hoodies': {name:'Hoodies', note:'Hoodies are cut with more ease than fitted tops; chest/bust remains the key body measurement.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','32–34','26–27','35–37','30–31'],['S','4–6','34–36','28–29','37–39','31–32'],['M','8–10','36–38','30–31','39–41','32–33'],['L','12–14','38–41','32–34','41–44','33–34'],['XL','16–18','41–44','35–37','44–47','34–35'],['2XL','20–22','44–47','38–40','47–50','35–36'],['3XL','24–26','47–50','41–43','50–53','36–37'],['4XL','28–30','50–53','44–46','53–56','37–38']]},
      'w-dresses': {name:'Dresses', note:'For dresses, compare bust, waist and hip. If one measurement is larger, size to that area.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37'],['S','4–6','35–36','28–29','38–39'],['M','8–10','37–38','30–31','40–41'],['L','12–14','39–41','32–34','42–44'],['XL','16–18','42–44','35–37','45–47'],['2XL','20–22','45–47','38–40','48–50'],['3XL','24–26','48–50','41–43','51–53'],['4XL','28–30','51–53','44–46','54–56']]},
      'w-sports': {name:'Sportswear', note:'Activewear is usually closer to the body. Use bust, waist and hip and consider stretch level.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Fit'], rows:[
        ['XS','0–2','32–33','25–26','35–36','Close'],['S','4–6','34–35','27–28','37–38','Close'],['M','8–10','36–37','29–30','39–40','Close'],['L','12–14','38–40','31–33','41–43','Close'],['XL','16–18','41–43','34–36','44–46','Close'],['2XL','20–22','44–46','37–39','47–49','Close'],['3XL','24–26','47–49','40–42','50–52','Close'],['4XL','28–30','50–52','43–45','53–55','Close']]},
      'w-sweatshirts': {name:'Sweatshirts', note:'Use bust first; sweatshirts typically allow more room than fitted tops.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','32–34','26–27','35–37','30–31'],['S','4–6','34–36','28–29','37–39','31–32'],['M','8–10','36–38','30–31','39–41','32–33'],['L','12–14','38–41','32–34','41–44','33–34'],['XL','16–18','41–44','35–37','44–47','34–35'],['2XL','20–22','44–47','38–40','47–50','35–36'],['3XL','24–26','47–50','41–43','50–53','36–37'],['4XL','28–30','50–53','44–46','53–56','37–38']]},
      'w-sweatpants': {name:'Sweatpants', note:'Choose sweatpants by waist and hip; the elastic waistband can change the fit.', cols:['Size','US Size','Waist (in)','Hip (in)','Typical Inseam (in)'], rows:[
        ['XS','0–2','25–26','35–36','28–30'],['S','4–6','27–28','37–38','29–31'],['M','8–10','29–30','39–40','30–32'],['L','12–14','31–33','41–43','30–32'],['XL','16–18','34–36','44–46','30–32'],['2XL','20–22','37–39','47–49','30–32'],['3XL','24–26','40–42','50–52','30–32'],['4XL','28–30','43–45','53–55','30–32']]},
      'w-onepieces': {name:'One-Pieces', note:'One-pieces need enough room through bust, waist and hip; torso fit can affect comfort.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Height Guide'], rows:[
        ['XS','0–2','33–34','26–27','36–37','5\'0"–5\'4"'],['S','4–6','35–36','28–29','38–39','5\'1"–5\'6"'],['M','8–10','37–38','30–31','40–41','5\'2"–5\'7"'],['L','12–14','39–41','32–34','42–44','5\'2"–5\'8"'],['XL','16–18','42–44','35–37','45–47','5\'2"–5\'9"'],['2XL','20–22','45–47','38–40','48–50','5\'2"–5\'9"'],['3XL','24–26','48–50','41–43','51–53','5\'2"–5\'9"'],['4XL','28–30','51–53','44–46','54–56','5\'2"–5\'9"']]},
      'w-bras': {name:"Women's Bras", note:'Bras are not universally sized XS–4XL. The alpha sizes below are a MYN2O convenience reference; use the product-specific band/cup chart whenever provided.', cols:['MYN2O Size','Typical US Band','Typical Cup Range','Underbust Guide (in)','Fit Note'], rows:[
        ['XS','30–32','A–B','25–28','Light / smaller bust'],['S','32–34','A–C','27–30','Light to medium'],['M','34–36','B–D','29–32','Medium'],['L','36–38','C–DD','31–34','Medium to fuller'],['XL','38–40','C–DD','33–36','Fuller'],['2XL','40–42','C–DDD','35–38','Fuller'],['3XL','42–44','C–DDD','37–40','Fuller'],['4XL','44–46','D–DDD','39–42','Fuller']]},
      'w-jackets': {name:'Jackets & Coats', note:'Outerwear should leave room for the layers you plan to wear underneath.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37','30–31'],['S','4–6','35–36','28–29','38–39','31–32'],['M','8–10','37–38','30–31','40–41','32–33'],['L','12–14','39–41','32–34','42–44','33–34'],['XL','16–18','42–44','35–37','45–47','34–35'],['2XL','20–22','45–47','38–40','48–50','35–36'],['3XL','24–26','48–50','41–43','51–53','36–37'],['4XL','28–30','51–53','44–46','54–56','37–38']]},
      'w-crop': {name:'Crop Tops & Camis', note:'For close-fitting crops and camis, bust and underbust are more important than hip.', cols:['Size','US Size','Bust (in)','Underbust (in)','Waist (in)','Fit'], rows:[
        ['XS','0–2','32–33','27–28','25–26','Close'],['S','4–6','34–35','29–30','27–28','Close'],['M','8–10','36–37','31–32','29–30','Close'],['L','12–14','38–40','33–34','31–33','Close'],['XL','16–18','41–43','35–36','34–36','Close'],['2XL','20–22','44–46','37–39','37–39','Close'],['3XL','24–26','47–49','40–42','40–42','Close'],['4XL','28–30','50–52','43–45','43–45','Close']]},
      'w-long': {name:'Long Sleeve Shirts', note:'Use bust first, then waist and hip. Sleeve length varies by cut and shoulder construction.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37','30–31'],['S','4–6','35–36','28–29','38–39','31–32'],['M','8–10','37–38','30–31','40–41','32–33'],['L','12–14','39–41','32–34','42–44','33–34'],['XL','16–18','42–44','35–37','45–47','34–35'],['2XL','20–22','45–47','38–40','48–50','35–36'],['3XL','24–26','48–50','41–43','51–53','36–37'],['4XL','28–30','51–53','44–46','54–56','37–38']]}
    };

    const M = {
      'm-jeans': {name:'Jeans', note:'Men’s denim is primarily waist + seat + inseam. Pick the inseam separately when available.', cols:['Size','US / Denim Waist','Waist (in)','Seat (in)','Inseam Options (in)'], rows:[
        ['XS','28–29','28–29','34–35','30 / 32 / 34'],['S','30–31','30–31','36–37','30 / 32 / 34'],['M','32–33','32–33','38–39','30 / 32 / 34'],['L','34–35','34–35','40–41','30 / 32 / 34'],['XL','36–38','36–38','42–44','30 / 32 / 34'],['2XL','40–42','40–42','46–48','30 / 32 / 34'],['3XL','44–46','44–46','50–52','30 / 32 / 34'],['4XL','48–50','48–50','54–56','30 / 32 / 34']]},
      'm-pants': {name:'Pants', note:'Dress, chino and casual pants use natural waist + seat; inseam depends on height and cut.', cols:['Size','US Waist','Waist (in)','Seat (in)','Typical Inseam (in)'], rows:[
        ['XS','28–29','28–29','34–35','30–32'],['S','30–31','30–31','36–37','30–32'],['M','32–33','32–33','38–39','30–32'],['L','34–35','34–35','40–41','30–32'],['XL','36–38','36–38','42–44','30–32'],['2XL','40–42','40–42','46–48','30–32'],['3XL','44–46','44–46','50–52','30–32'],['4XL','48–50','48–50','54–56','30–32']]},
      'm-shirts': {name:'Shirts', note:'For woven shirts, chest is the main measurement; neck size can matter for tailored collars.', cols:['Size','US Alpha','Neck (in)','Chest (in)','Waist (in)','Seat (in)'], rows:[
        ['XS','XS','14.75–15','32–34','26–28','32–34'],['S','S','15–15.25','35–37','29–31','35–37'],['M','M','15.5–15.75','38–40','32–34','38–40'],['L','L','16–16.5','41–43','35–37','41–43'],['XL','XL','16.75–17.25','44–46','38–40','44–46'],['2XL','XXL','17.5–18','47–49','41–43','47–49'],['3XL','3XL','18.25–18.75','50–52','44–46','50–52'],['4XL','4XL','19–19.5','53–55','47–49','53–55']]},
      'm-shorts': {name:'Shorts', note:'Shorts are selected mainly by waist and seat; inseam changes the overall silhouette.', cols:['Size','US Waist','Waist (in)','Seat (in)','Typical Inseam (in)'], rows:[
        ['XS','28–29','28–29','34–35','5–7'],['S','30–31','30–31','36–37','6–8'],['M','32–33','32–33','38–39','7–9'],['L','34–35','34–35','40–41','7–10'],['XL','36–38','36–38','42–44','7–10'],['2XL','40–42','40–42','46–48','7–11'],['3XL','44–46','44–46','50–52','7–11'],['4XL','48–50','48–50','54–56','7–11']]},
      'm-tees': {name:'T-Shirts', note:'Chest is the key measurement. Slim, regular and oversized fits can use the same body size but feel very different.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34'],['S','S','35–37','29–31','35–37'],['M','M','38–40','32–34','38–40'],['L','L','41–43','35–37','41–43'],['XL','XL','44–46','38–40','44–46'],['2XL','XXL','47–49','41–43','47–49'],['3XL','3XL','50–52','44–46','50–52'],['4XL','4XL','53–55','47–49','53–55']]},
      'm-hoodies': {name:'Hoodies', note:'Hoodies are intentionally roomier. Use chest first and allow for the intended relaxed ease.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-sweaters': {name:'Sweaters', note:'Layering changes sweater fit. Compare chest and waist, especially when wearing a shirt underneath.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-tanks': {name:'Tank Tops', note:'Tank tops are closer to the body around the chest and arm opening; use chest as the first reference.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Fit'], rows:[
        ['XS','XS','32–34','26–28','32–34','Close'],['S','S','35–37','29–31','35–37','Close'],['M','M','38–40','32–34','38–40','Close'],['L','L','41–43','35–37','41–43','Close'],['XL','XL','44–46','38–40','44–46','Close'],['2XL','XXL','47–49','41–43','47–49','Close'],['3XL','3XL','50–52','44–46','50–52','Close'],['4XL','4XL','53–55','47–49','53–55','Close']]},
      'm-sports': {name:'Sportswear', note:'Active styles vary from compression to relaxed. Match chest, waist and seat, then follow the product fit note.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Fit'], rows:[
        ['XS','XS','32–34','26–28','32–34','Athletic'],['S','S','35–37','29–31','35–37','Athletic'],['M','M','38–40','32–34','38–40','Athletic'],['L','L','41–43','35–37','41–43','Athletic'],['XL','XL','44–46','38–40','44–46','Athletic'],['2XL','XXL','47–49','41–43','47–49','Athletic'],['3XL','3XL','50–52','44–46','50–52','Athletic'],['4XL','4XL','53–55','47–49','53–55','Athletic']]},
      'm-sweatshirts': {name:'Sweatshirts', note:'Use chest as the primary measurement; sweatshirts generally include more ease than tees.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-sweatpants': {name:'Sweatpants', note:'Use waist + seat; elastic and drawstrings can provide extra flexibility.', cols:['Size','US Waist','Waist (in)','Seat (in)','Typical Inseam (in)'], rows:[
        ['XS','28–29','28–29','34–35','30–32'],['S','30–31','30–31','36–37','30–32'],['M','32–33','32–33','38–39','30–32'],['L','34–35','34–35','40–41','30–32'],['XL','36–38','36–38','42–44','30–32'],['2XL','40–42','40–42','46–48','30–32'],['3XL','44–46','44–46','50–52','30–32'],['4XL','48–50','48–50','54–56','30–32']]},
      'm-jackets': {name:'Jackets & Coats', note:'Outerwear should accommodate the layers underneath. Chest and sleeve length are especially important.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-long': {name:'Long Sleeve Shirts', note:'Chest is primary; sleeve length varies by shoulder construction and shirt silhouette.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]}
    };

    function byId(id) {
      return root.querySelector('#' + CSS.escape(id));
    }

    function renderChart(type, key) {
      const data = (type === 'women' ? W : M)[key];
      if (!data) return;

      const prefix = type === 'women' ? 'women' : 'men';
      const table = byId(prefix + '-size-table');
      const title = byId(prefix + '-chart-title');
      const subtitle = byId(prefix + '-chart-subtitle');
      const measureCard = byId(prefix + '-measure-card');

      if (!table) return;

      if (title) {
        title.textContent =
          `${type === 'women' ? 'Women’s' : 'Men’s'} ${data.name} — US Size Chart`;
      }

      if (subtitle) {
        subtitle.textContent =
          'Category-specific U.S. market reference • body measurements in inches';
      }

      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');

      if (thead) {
        thead.innerHTML =
          '<tr>' +
          data.cols.map(function (c) {
            return '<th>' + c + '</th>';
          }).join('') +
          '</tr>';
      }

      if (tbody) {
        tbody.innerHTML = data.rows.map(function (row) {
          return '<tr>' + row.map(function (value, index) {
            return index === 0
              ? '<td><strong>' + value + '</strong></td>'
              : '<td>' + value + '</td>';
          }).join('') + '</tr>';
        }).join('');
      }

      const steps = type === 'women'
        ? [
            ['Bust', 'Measure around the fullest part of your bust, keeping the tape level.'],
            ['Waist', 'Measure around your natural waist without pulling the tape tight.'],
            ['Hips', 'Measure around the fullest part of your hips and seat.'],
            ['Category focus', data.note]
          ]
        : [
            ['Chest', 'Measure around the fullest part of your chest, keeping the tape level.'],
            ['Waist', 'Measure around your natural waist where your pants normally sit.'],
            ['Seat', 'Measure around the fullest part of your seat.'],
            ['Category focus', data.note]
          ];

      if (measureCard) {
        measureCard.innerHTML =
          '<h3>How to Measure</h3>' +
          steps.map(function (step, index) {
            return (
              '<div class="measure-step">' +
                '<div class="num">' + (index + 1) + '</div>' +
                '<div>' +
                  '<strong>' + step[0] + '</strong>' +
                  '<span>' + step[1] + '</span>' +
                '</div>' +
              '</div>'
            );
          }).join('');
      }
    }

    // Category buttons.
    root.querySelectorAll('.category-nav').forEach(function (group) {
      group.addEventListener('click', function (event) {
        const btn = event.target.closest('.cat-btn');
        if (!btn || !group.contains(btn)) return;

        group.querySelectorAll('.cat-btn').forEach(function (item) {
          item.classList.remove('active');
        });

        btn.classList.add('active');

        const type = group.dataset.categoryGroup;
        renderChart(type, btn.dataset.category);
      });

      const first = group.querySelector('.cat-btn.active') || group.querySelector('.cat-btn');

      if (first) {
        renderChart(group.dataset.categoryGroup, first.dataset.category);
      }
    });

    // Top Women / Men / Kids / Jewelry navigation.
    const tabsWrap = root.querySelector('.tabs');

    if (tabsWrap) {
      tabsWrap.addEventListener('click', function (event) {
        const tab = event.target.closest('.tab');

        if (!tab || !tabsWrap.contains(tab)) return;

        event.preventDefault();
        event.stopPropagation();

        const id = tab.dataset.target;
        if (!id) return;

        const target = byId(id);

        if (!target) {
          console.warn('[MYN2O] Target section not found:', id);
          return;
        }

        root.querySelectorAll('.tab').forEach(function (item) {
          item.classList.toggle('active', item === tab);
        });

        scrollToSection(root, target);
      });
    }

    // Update active tab while user manually scrolls.
    setupSectionObserver(root);
  }

  function refreshInitialCharts(root) {
    root.querySelectorAll('.category-nav').forEach(function (group) {
      const active = group.querySelector('.cat-btn.active') || group.querySelector('.cat-btn');
      if (active) active.click();
    });
  }

  function findScrollableAncestor(target, root) {
    let node = target.parentElement;

    while (node && node !== document.body && node !== document.documentElement) {
      const style = window.getComputedStyle(node);
      const overflowY = style.overflowY;

      const scrollable =
        (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
        node.scrollHeight > node.clientHeight + 2;

      if (scrollable) return node;

      // Once we pass the content root, continue upward because
      // the actual Beae popup scroller may wrap the entire injected HTML.
      node = node.parentElement;
    }

    return null;
  }

  function scrollToSection(root, target) {
    const scrollParent = findScrollableAncestor(target, root);

    if (scrollParent) {
      const parentRect = scrollParent.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      // Account for the sticky tabs inside the popup.
      const tabs = root.querySelector('.tabs');
      const tabsHeight = tabs ? tabs.getBoundingClientRect().height : 0;

      const top =
        scrollParent.scrollTop +
        (targetRect.top - parentRect.top) -
        tabsHeight -
        10;

      scrollParent.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });

      return;
    }

    // Browser fallback. scrollIntoView normally scrolls the nearest
    // scrollable ancestor even when the content is inside a modal.
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  function setupSectionObserver(root) {
    if (!('IntersectionObserver' in window)) return;

    const sections = Array.from(root.querySelectorAll('.size-section'));
    const tabs = Array.from(root.querySelectorAll('.tab'));

    if (!sections.length || !tabs.length) return;

    const scrollParent = findScrollableAncestor(sections[0], root);

    try {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          tabs.forEach(function (tab) {
            tab.classList.toggle(
              'active',
              tab.dataset.target === entry.target.id
            );
          });
        });
      }, {
        root: scrollParent || null,
        rootMargin: '-30% 0px -55% 0px',
        threshold: 0
      });

      sections.forEach(function (section) {
        observer.observe(section);
      });
    } catch (error) {
      console.warn('[MYN2O] Section observer could not initialize:', error);
    }
  }
})();
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "undefined";
              window.beaePageSetting.pageTitle = "Shop Premium Fashion & Lifestyle Products Online | MYN2O"; 
              window.beaePageSetting.pageType = "product";

          let js_96DIFRJ6 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-09gav3xssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-09gav3xs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-09gav3xs');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-09gav3xs: ', ex)
      };
    }; if (window.BEAEBASE) {js_96DIFRJ6()} else {window.BEAEPAGEJS.push(js_96DIFRJ6)} })(); (function () {
  const BUTTON_SELECTOR = '.beae-variant-size-guide-btn';
  const INIT_ATTR = 'data-myn2o-size-guide-initialized';

  // Click listener works even if Beae dynamically renders the button.
  document.addEventListener('click', function (event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    waitForSizeGuide();
  });

  function waitForSizeGuide() {
    let tries = 0;
    const maxTries = 60;

    const timer = setInterval(function () {
      tries++;

      const context = findSizeGuideContext();

      if (context) {
        clearInterval(timer);
        initSizeGuide(context.root);
        return;
      }

      if (tries >= maxTries) {
        clearInterval(timer);
        console.warn('[MYN2O] Size guide HTML was not found after popup open.');
      }
    }, 100);
  }

  function isVisible(el) {
    if (!el) return false;

    const style = window.getComputedStyle(el);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      el.getClientRects().length > 0
    );
  }

  function getCommonAncestor(a, b) {
    if (!a || !b) return null;

    const parents = [];
    let node = a;

    while (node) {
      parents.push(node);
      node = node.parentElement;
    }

    node = b;

    while (node) {
      if (parents.includes(node)) return node;
      node = node.parentElement;
    }

    return null;
  }

  function findSizeGuideContext() {
    // The supplied HTML always has:
    // .tabs
    // #women.size-section
    // #men.size-section
    // #kids.size-section
    // #jewelry.size-section
    //
    // Prefer the visible copy because Beae may leave a hidden template in the DOM.
    const allTabs = Array.from(document.querySelectorAll('.tabs'));

    for (const tabs of allTabs) {
      if (!isVisible(tabs)) continue;

      let scope = tabs.parentElement;

      // Walk upward until this same DOM branch contains the matching sections.
      while (scope && scope !== document.documentElement) {
        const women = scope.querySelector('#women.size-section');
        const men = scope.querySelector('#men.size-section');
        const kids = scope.querySelector('#kids.size-section');
        const jewelry = scope.querySelector('#jewelry.size-section');

        if (women && men && kids && jewelry) {
          const common = getCommonAncestor(tabs, women);
          return {
            root: common || scope,
            tabs: tabs
          };
        }

        scope = scope.parentElement;
      }
    }

    return null;
  }

  function initSizeGuide(root) {
    if (!root) return;

    // If Beae reuses the same popup DOM, don't bind duplicate listeners.
    if (root.getAttribute(INIT_ATTR) === 'true') {
      refreshInitialCharts(root);
      return;
    }

    root.setAttribute(INIT_ATTR, 'true');

    const W = {
      'w-tops': {name:'Tops', note:'Fitted and regular tops are primarily chosen by bust, then waist and hip.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37'],['S','4–6','35–36','28–29','38–39'],['M','8–10','37–38','30–31','40–41'],['L','12–14','39–41','32–34','42–44'],['XL','16–18','42–44','35–37','45–47'],['2XL','20–22','45–47','38–40','48–50'],['3XL','24–26','48–50','41–43','51–53'],['4XL','28–30','51–53','44–46','54–56']]},
      'w-jeans': {name:'Jeans', note:'Denim sizing is driven by waist and hip. Choose the inseam separately when offered.', cols:['Size','US / Denim Waist','Waist (in)','Hip (in)','Inseam Options (in)'], rows:[
        ['XS','24–25','24–25','34–35','28 / 30 / 32'],['S','26–27','26–27','36–37','28 / 30 / 32'],['M','28–29','28–29','38–39','28 / 30 / 32'],['L','30–31','30–31','40–41','28 / 30 / 32'],['XL','32–34','32–34','42–44','28 / 30 / 32'],['2XL','35–37','35–37','45–47','28 / 30 / 32'],['3XL','38–40','38–40','48–50','28 / 30 / 32'],['4XL','41–43','41–43','51–53','28 / 30 / 32']]},
      'w-shorts': {name:'Shorts', note:'For shorts, match your natural waist and fullest hip; inseam varies by short style.', cols:['Size','US Size','Waist (in)','Hip (in)','Typical Inseam (in)'], rows:[
        ['XS','0–2','25–26','35–36','2–4'],['S','4–6','27–28','37–38','3–5'],['M','8–10','29–30','39–40','4–6'],['L','12–14','31–33','41–43','5–7'],['XL','16–18','34–36','44–46','5–8'],['2XL','20–22','37–39','47–49','5–8'],['3XL','24–26','40–42','50–52','6–9'],['4XL','28–30','43–45','53–55','6–9']]},
      'w-skirts': {name:'Skirts', note:'Skirts are generally sized from the waistband and hip. Length is style-specific.', cols:['Size','US Size','Waist (in)','Hip (in)','Typical Length Note'], rows:[
        ['XS','0–2','25–26','35–36','Mini / Midi / Maxi'],['S','4–6','27–28','37–38','Mini / Midi / Maxi'],['M','8–10','29–30','39–40','Mini / Midi / Maxi'],['L','12–14','31–33','41–43','Mini / Midi / Maxi'],['XL','16–18','34–36','44–46','Mini / Midi / Maxi'],['2XL','20–22','37–39','47–49','Mini / Midi / Maxi'],['3XL','24–26','40–42','50–52','Mini / Midi / Maxi'],['4XL','28–30','43–45','53–55','Mini / Midi / Maxi']]},
      'w-tees': {name:'T-Shirts', note:'T-shirts use bust/chest as the primary reference. Relaxed and oversized fits intentionally add ease.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)'], rows:[
        ['XS','0–2','32–33','25–26','35–36'],['S','4–6','34–35','27–28','37–38'],['M','8–10','36–37','29–30','39–40'],['L','12–14','38–40','31–33','41–43'],['XL','16–18','41–43','34–36','44–46'],['2XL','20–22','44–46','37–39','47–49'],['3XL','24–26','47–49','40–42','50–52'],['4XL','28–30','50–52','43–45','53–55']]},
      'w-hoodies': {name:'Hoodies', note:'Hoodies are cut with more ease than fitted tops; chest/bust remains the key body measurement.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','32–34','26–27','35–37','30–31'],['S','4–6','34–36','28–29','37–39','31–32'],['M','8–10','36–38','30–31','39–41','32–33'],['L','12–14','38–41','32–34','41–44','33–34'],['XL','16–18','41–44','35–37','44–47','34–35'],['2XL','20–22','44–47','38–40','47–50','35–36'],['3XL','24–26','47–50','41–43','50–53','36–37'],['4XL','28–30','50–53','44–46','53–56','37–38']]},
      'w-dresses': {name:'Dresses', note:'For dresses, compare bust, waist and hip. If one measurement is larger, size to that area.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37'],['S','4–6','35–36','28–29','38–39'],['M','8–10','37–38','30–31','40–41'],['L','12–14','39–41','32–34','42–44'],['XL','16–18','42–44','35–37','45–47'],['2XL','20–22','45–47','38–40','48–50'],['3XL','24–26','48–50','41–43','51–53'],['4XL','28–30','51–53','44–46','54–56']]},
      'w-sports': {name:'Sportswear', note:'Activewear is usually closer to the body. Use bust, waist and hip and consider stretch level.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Fit'], rows:[
        ['XS','0–2','32–33','25–26','35–36','Close'],['S','4–6','34–35','27–28','37–38','Close'],['M','8–10','36–37','29–30','39–40','Close'],['L','12–14','38–40','31–33','41–43','Close'],['XL','16–18','41–43','34–36','44–46','Close'],['2XL','20–22','44–46','37–39','47–49','Close'],['3XL','24–26','47–49','40–42','50–52','Close'],['4XL','28–30','50–52','43–45','53–55','Close']]},
      'w-sweatshirts': {name:'Sweatshirts', note:'Use bust first; sweatshirts typically allow more room than fitted tops.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','32–34','26–27','35–37','30–31'],['S','4–6','34–36','28–29','37–39','31–32'],['M','8–10','36–38','30–31','39–41','32–33'],['L','12–14','38–41','32–34','41–44','33–34'],['XL','16–18','41–44','35–37','44–47','34–35'],['2XL','20–22','44–47','38–40','47–50','35–36'],['3XL','24–26','47–50','41–43','50–53','36–37'],['4XL','28–30','50–53','44–46','53–56','37–38']]},
      'w-sweatpants': {name:'Sweatpants', note:'Choose sweatpants by waist and hip; the elastic waistband can change the fit.', cols:['Size','US Size','Waist (in)','Hip (in)','Typical Inseam (in)'], rows:[
        ['XS','0–2','25–26','35–36','28–30'],['S','4–6','27–28','37–38','29–31'],['M','8–10','29–30','39–40','30–32'],['L','12–14','31–33','41–43','30–32'],['XL','16–18','34–36','44–46','30–32'],['2XL','20–22','37–39','47–49','30–32'],['3XL','24–26','40–42','50–52','30–32'],['4XL','28–30','43–45','53–55','30–32']]},
      'w-onepieces': {name:'One-Pieces', note:'One-pieces need enough room through bust, waist and hip; torso fit can affect comfort.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Height Guide'], rows:[
        ['XS','0–2','33–34','26–27','36–37','5\'0"–5\'4"'],['S','4–6','35–36','28–29','38–39','5\'1"–5\'6"'],['M','8–10','37–38','30–31','40–41','5\'2"–5\'7"'],['L','12–14','39–41','32–34','42–44','5\'2"–5\'8"'],['XL','16–18','42–44','35–37','45–47','5\'2"–5\'9"'],['2XL','20–22','45–47','38–40','48–50','5\'2"–5\'9"'],['3XL','24–26','48–50','41–43','51–53','5\'2"–5\'9"'],['4XL','28–30','51–53','44–46','54–56','5\'2"–5\'9"']]},
      'w-bras': {name:"Women's Bras", note:'Bras are not universally sized XS–4XL. The alpha sizes below are a MYN2O convenience reference; use the product-specific band/cup chart whenever provided.', cols:['MYN2O Size','Typical US Band','Typical Cup Range','Underbust Guide (in)','Fit Note'], rows:[
        ['XS','30–32','A–B','25–28','Light / smaller bust'],['S','32–34','A–C','27–30','Light to medium'],['M','34–36','B–D','29–32','Medium'],['L','36–38','C–DD','31–34','Medium to fuller'],['XL','38–40','C–DD','33–36','Fuller'],['2XL','40–42','C–DDD','35–38','Fuller'],['3XL','42–44','C–DDD','37–40','Fuller'],['4XL','44–46','D–DDD','39–42','Fuller']]},
      'w-jackets': {name:'Jackets & Coats', note:'Outerwear should leave room for the layers you plan to wear underneath.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37','30–31'],['S','4–6','35–36','28–29','38–39','31–32'],['M','8–10','37–38','30–31','40–41','32–33'],['L','12–14','39–41','32–34','42–44','33–34'],['XL','16–18','42–44','35–37','45–47','34–35'],['2XL','20–22','45–47','38–40','48–50','35–36'],['3XL','24–26','48–50','41–43','51–53','36–37'],['4XL','28–30','51–53','44–46','54–56','37–38']]},
      'w-crop': {name:'Crop Tops & Camis', note:'For close-fitting crops and camis, bust and underbust are more important than hip.', cols:['Size','US Size','Bust (in)','Underbust (in)','Waist (in)','Fit'], rows:[
        ['XS','0–2','32–33','27–28','25–26','Close'],['S','4–6','34–35','29–30','27–28','Close'],['M','8–10','36–37','31–32','29–30','Close'],['L','12–14','38–40','33–34','31–33','Close'],['XL','16–18','41–43','35–36','34–36','Close'],['2XL','20–22','44–46','37–39','37–39','Close'],['3XL','24–26','47–49','40–42','40–42','Close'],['4XL','28–30','50–52','43–45','43–45','Close']]},
      'w-long': {name:'Long Sleeve Shirts', note:'Use bust first, then waist and hip. Sleeve length varies by cut and shoulder construction.', cols:['Size','US Size','Bust (in)','Waist (in)','Hip (in)','Sleeve (in)'], rows:[
        ['XS','0–2','33–34','26–27','36–37','30–31'],['S','4–6','35–36','28–29','38–39','31–32'],['M','8–10','37–38','30–31','40–41','32–33'],['L','12–14','39–41','32–34','42–44','33–34'],['XL','16–18','42–44','35–37','45–47','34–35'],['2XL','20–22','45–47','38–40','48–50','35–36'],['3XL','24–26','48–50','41–43','51–53','36–37'],['4XL','28–30','51–53','44–46','54–56','37–38']]}
    };

    const M = {
      'm-jeans': {name:'Jeans', note:'Men’s denim is primarily waist + seat + inseam. Pick the inseam separately when available.', cols:['Size','US / Denim Waist','Waist (in)','Seat (in)','Inseam Options (in)'], rows:[
        ['XS','28–29','28–29','34–35','30 / 32 / 34'],['S','30–31','30–31','36–37','30 / 32 / 34'],['M','32–33','32–33','38–39','30 / 32 / 34'],['L','34–35','34–35','40–41','30 / 32 / 34'],['XL','36–38','36–38','42–44','30 / 32 / 34'],['2XL','40–42','40–42','46–48','30 / 32 / 34'],['3XL','44–46','44–46','50–52','30 / 32 / 34'],['4XL','48–50','48–50','54–56','30 / 32 / 34']]},
      'm-pants': {name:'Pants', note:'Dress, chino and casual pants use natural waist + seat; inseam depends on height and cut.', cols:['Size','US Waist','Waist (in)','Seat (in)','Typical Inseam (in)'], rows:[
        ['XS','28–29','28–29','34–35','30–32'],['S','30–31','30–31','36–37','30–32'],['M','32–33','32–33','38–39','30–32'],['L','34–35','34–35','40–41','30–32'],['XL','36–38','36–38','42–44','30–32'],['2XL','40–42','40–42','46–48','30–32'],['3XL','44–46','44–46','50–52','30–32'],['4XL','48–50','48–50','54–56','30–32']]},
      'm-shirts': {name:'Shirts', note:'For woven shirts, chest is the main measurement; neck size can matter for tailored collars.', cols:['Size','US Alpha','Neck (in)','Chest (in)','Waist (in)','Seat (in)'], rows:[
        ['XS','XS','14.75–15','32–34','26–28','32–34'],['S','S','15–15.25','35–37','29–31','35–37'],['M','M','15.5–15.75','38–40','32–34','38–40'],['L','L','16–16.5','41–43','35–37','41–43'],['XL','XL','16.75–17.25','44–46','38–40','44–46'],['2XL','XXL','17.5–18','47–49','41–43','47–49'],['3XL','3XL','18.25–18.75','50–52','44–46','50–52'],['4XL','4XL','19–19.5','53–55','47–49','53–55']]},
      'm-shorts': {name:'Shorts', note:'Shorts are selected mainly by waist and seat; inseam changes the overall silhouette.', cols:['Size','US Waist','Waist (in)','Seat (in)','Typical Inseam (in)'], rows:[
        ['XS','28–29','28–29','34–35','5–7'],['S','30–31','30–31','36–37','6–8'],['M','32–33','32–33','38–39','7–9'],['L','34–35','34–35','40–41','7–10'],['XL','36–38','36–38','42–44','7–10'],['2XL','40–42','40–42','46–48','7–11'],['3XL','44–46','44–46','50–52','7–11'],['4XL','48–50','48–50','54–56','7–11']]},
      'm-tees': {name:'T-Shirts', note:'Chest is the key measurement. Slim, regular and oversized fits can use the same body size but feel very different.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34'],['S','S','35–37','29–31','35–37'],['M','M','38–40','32–34','38–40'],['L','L','41–43','35–37','41–43'],['XL','XL','44–46','38–40','44–46'],['2XL','XXL','47–49','41–43','47–49'],['3XL','3XL','50–52','44–46','50–52'],['4XL','4XL','53–55','47–49','53–55']]},
      'm-hoodies': {name:'Hoodies', note:'Hoodies are intentionally roomier. Use chest first and allow for the intended relaxed ease.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-sweaters': {name:'Sweaters', note:'Layering changes sweater fit. Compare chest and waist, especially when wearing a shirt underneath.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-tanks': {name:'Tank Tops', note:'Tank tops are closer to the body around the chest and arm opening; use chest as the first reference.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Fit'], rows:[
        ['XS','XS','32–34','26–28','32–34','Close'],['S','S','35–37','29–31','35–37','Close'],['M','M','38–40','32–34','38–40','Close'],['L','L','41–43','35–37','41–43','Close'],['XL','XL','44–46','38–40','44–46','Close'],['2XL','XXL','47–49','41–43','47–49','Close'],['3XL','3XL','50–52','44–46','50–52','Close'],['4XL','4XL','53–55','47–49','53–55','Close']]},
      'm-sports': {name:'Sportswear', note:'Active styles vary from compression to relaxed. Match chest, waist and seat, then follow the product fit note.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Fit'], rows:[
        ['XS','XS','32–34','26–28','32–34','Athletic'],['S','S','35–37','29–31','35–37','Athletic'],['M','M','38–40','32–34','38–40','Athletic'],['L','L','41–43','35–37','41–43','Athletic'],['XL','XL','44–46','38–40','44–46','Athletic'],['2XL','XXL','47–49','41–43','47–49','Athletic'],['3XL','3XL','50–52','44–46','50–52','Athletic'],['4XL','4XL','53–55','47–49','53–55','Athletic']]},
      'm-sweatshirts': {name:'Sweatshirts', note:'Use chest as the primary measurement; sweatshirts generally include more ease than tees.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-sweatpants': {name:'Sweatpants', note:'Use waist + seat; elastic and drawstrings can provide extra flexibility.', cols:['Size','US Waist','Waist (in)','Seat (in)','Typical Inseam (in)'], rows:[
        ['XS','28–29','28–29','34–35','30–32'],['S','30–31','30–31','36–37','30–32'],['M','32–33','32–33','38–39','30–32'],['L','34–35','34–35','40–41','30–32'],['XL','36–38','36–38','42–44','30–32'],['2XL','40–42','40–42','46–48','30–32'],['3XL','44–46','44–46','50–52','30–32'],['4XL','48–50','48–50','54–56','30–32']]},
      'm-jackets': {name:'Jackets & Coats', note:'Outerwear should accommodate the layers underneath. Chest and sleeve length are especially important.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]},
      'm-long': {name:'Long Sleeve Shirts', note:'Chest is primary; sleeve length varies by shoulder construction and shirt silhouette.', cols:['Size','US Alpha','Chest (in)','Waist (in)','Seat (in)','Sleeve (in)'], rows:[
        ['XS','XS','32–34','26–28','32–34','30–31'],['S','S','35–37','29–31','35–37','32–33'],['M','M','38–40','32–34','38–40','33–34'],['L','L','41–43','35–37','41–43','34–35'],['XL','XL','44–46','38–40','44–46','35–36'],['2XL','XXL','47–49','41–43','47–49','36–37'],['3XL','3XL','50–52','44–46','50–52','37–38'],['4XL','4XL','53–55','47–49','53–55','38–39']]}
    };

    function byId(id) {
      return root.querySelector('#' + CSS.escape(id));
    }

    function renderChart(type, key) {
      const data = (type === 'women' ? W : M)[key];
      if (!data) return;

      const prefix = type === 'women' ? 'women' : 'men';
      const table = byId(prefix + '-size-table');
      const title = byId(prefix + '-chart-title');
      const subtitle = byId(prefix + '-chart-subtitle');
      const measureCard = byId(prefix + '-measure-card');

      if (!table) return;

      if (title) {
        title.textContent =
          `${type === 'women' ? 'Women’s' : 'Men’s'} ${data.name} — US Size Chart`;
      }

      if (subtitle) {
        subtitle.textContent =
          'Category-specific U.S. market reference • body measurements in inches';
      }

      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');

      if (thead) {
        thead.innerHTML =
          '<tr>' +
          data.cols.map(function (c) {
            return '<th>' + c + '</th>';
          }).join('') +
          '</tr>';
      }

      if (tbody) {
        tbody.innerHTML = data.rows.map(function (row) {
          return '<tr>' + row.map(function (value, index) {
            return index === 0
              ? '<td><strong>' + value + '</strong></td>'
              : '<td>' + value + '</td>';
          }).join('') + '</tr>';
        }).join('');
      }

      const steps = type === 'women'
        ? [
            ['Bust', 'Measure around the fullest part of your bust, keeping the tape level.'],
            ['Waist', 'Measure around your natural waist without pulling the tape tight.'],
            ['Hips', 'Measure around the fullest part of your hips and seat.'],
            ['Category focus', data.note]
          ]
        : [
            ['Chest', 'Measure around the fullest part of your chest, keeping the tape level.'],
            ['Waist', 'Measure around your natural waist where your pants normally sit.'],
            ['Seat', 'Measure around the fullest part of your seat.'],
            ['Category focus', data.note]
          ];

      if (measureCard) {
        measureCard.innerHTML =
          '<h3>How to Measure</h3>' +
          steps.map(function (step, index) {
            return (
              '<div class="measure-step">' +
                '<div class="num">' + (index + 1) + '</div>' +
                '<div>' +
                  '<strong>' + step[0] + '</strong>' +
                  '<span>' + step[1] + '</span>' +
                '</div>' +
              '</div>'
            );
          }).join('');
      }
    }

    // Category buttons.
    root.querySelectorAll('.category-nav').forEach(function (group) {
      group.addEventListener('click', function (event) {
        const btn = event.target.closest('.cat-btn');
        if (!btn || !group.contains(btn)) return;

        group.querySelectorAll('.cat-btn').forEach(function (item) {
          item.classList.remove('active');
        });

        btn.classList.add('active');

        const type = group.dataset.categoryGroup;
        renderChart(type, btn.dataset.category);
      });

      const first = group.querySelector('.cat-btn.active') || group.querySelector('.cat-btn');

      if (first) {
        renderChart(group.dataset.categoryGroup, first.dataset.category);
      }
    });

    // Top Women / Men / Kids / Jewelry navigation.
    const tabsWrap = root.querySelector('.tabs');

    if (tabsWrap) {
      tabsWrap.addEventListener('click', function (event) {
        const tab = event.target.closest('.tab');

        if (!tab || !tabsWrap.contains(tab)) return;

        event.preventDefault();
        event.stopPropagation();

        const id = tab.dataset.target;
        if (!id) return;

        const target = byId(id);

        if (!target) {
          console.warn('[MYN2O] Target section not found:', id);
          return;
        }

        root.querySelectorAll('.tab').forEach(function (item) {
          item.classList.toggle('active', item === tab);
        });

        scrollToSection(root, target);
      });
    }

    // Update active tab while user manually scrolls.
    setupSectionObserver(root);
  }

  function refreshInitialCharts(root) {
    root.querySelectorAll('.category-nav').forEach(function (group) {
      const active = group.querySelector('.cat-btn.active') || group.querySelector('.cat-btn');
      if (active) active.click();
    });
  }

  function findScrollableAncestor(target, root) {
    let node = target.parentElement;

    while (node && node !== document.body && node !== document.documentElement) {
      const style = window.getComputedStyle(node);
      const overflowY = style.overflowY;

      const scrollable =
        (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
        node.scrollHeight > node.clientHeight + 2;

      if (scrollable) return node;

      // Once we pass the content root, continue upward because
      // the actual Beae popup scroller may wrap the entire injected HTML.
      node = node.parentElement;
    }

    return null;
  }

  function scrollToSection(root, target) {
    const scrollParent = findScrollableAncestor(target, root);

    if (scrollParent) {
      const parentRect = scrollParent.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();

      // Account for the sticky tabs inside the popup.
      const tabs = root.querySelector('.tabs');
      const tabsHeight = tabs ? tabs.getBoundingClientRect().height : 0;

      const top =
        scrollParent.scrollTop +
        (targetRect.top - parentRect.top) -
        tabsHeight -
        10;

      scrollParent.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });

      return;
    }

    // Browser fallback. scrollIntoView normally scrolls the nearest
    // scrollable ancestor even when the content is inside a modal.
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  function setupSectionObserver(root) {
    if (!('IntersectionObserver' in window)) return;

    const sections = Array.from(root.querySelectorAll('.size-section'));
    const tabs = Array.from(root.querySelectorAll('.tab'));

    if (!sections.length || !tabs.length) return;

    const scrollParent = findScrollableAncestor(sections[0], root);

    try {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          tabs.forEach(function (tab) {
            tab.classList.toggle(
              'active',
              tab.dataset.target === entry.target.id
            );
          });
        });
      }, {
        root: scrollParent || null,
        rootMargin: '-30% 0px -55% 0px',
        threshold: 0
      });

      sections.forEach(function (section) {
        observer.observe(section);
      });
    } catch (error) {
      console.warn('[MYN2O] Section observer could not initialize:', error);
    }
  }
})();